export function me($auth) {

	"ngInject";

	return () => $auth.getUser();

}

export function isMe($auth) {

	"ngInject";

	return (userUrl) => $auth.isAuthenticated() ? userUrl === $auth.getUser().uri : false;

}


// WEBPACK FOOTER //
// ./sources/filters/me.js